// ghFilterAdvanced and ghRecycleBinTable are not required here: they're already eagerly
// bundled into the main app entry (main.js), and re-requiring them here duplicates their
// registration when this file is pulled into the separate recycle_bin_data async webpack
// bundle, causing AngularJS's $compile:multidir error the moment the Recycle Bin dialog
// (or its table) is compiled.
require('./recycle_bin.scss')
require('../../core/localizationService/localizationService.js')

angular.module('ghRecycleBinModule', ['localizationModule', 'ghRecycleBinTableModule'])
.directive('ghRecycleBin', [
  function() {
  return {
    scope: {
      fieldModel: '='
    },
    controller: ['$scope', '$element', '$timeout', 'GhDialog', 'ghToastService', 'localizationService', async function($scope, $element, $timeout, GhDialog, ghToastService, localizationService){
      const instance = await gudhub.ghconstructor.getInstance('recycle_bin');
      const dictionary = instance.getDictionary();
      $scope.translate = (word) => localizationService.translate(word, dictionary);
      $scope.isShowLoader = false;

      $scope.openDialog = async () => {
        if(!$scope.fieldModel.data_model.app_id) {
          return;
        }
        $scope.app = await gudhub.getApp($scope.fieldModel.data_model.app_id);
        $scope.trashItems = $scope.app.trash_items;
        
        {
          $scope.isShowLoader = true;
          // Preserve previously toggled show/hide state and any custom width across dialog
          // reopens instead of resetting every column. Always rebuilt (not just for mode
          // 'app') so a field list saved before this constructor==='field' filter existed
          // (or containing action-type fields like Calendar/App Table) gets self-healed too.
          const existingFields = $scope.fieldModel.data_model.fields || [];
          $scope.fields = []

          for(field of $scope.app.field_list) {
            const instance = await gudhub.ghconstructor.getInstance(field.data_type);
			      if(instance && instance.getTemplate().constructor === 'field') {
              const existingField = existingFields.find((f) => f.field_id === field.field_id);
              $scope.fields.push({
                field_id: field.field_id,
                field_name: field.field_name,
                show: existingField ? existingField.show : 1,
                width: existingField ? existingField.width : '150px'
              })
            }
          }

          $scope.fieldModel.data_model.fields = $scope.fields;
          $scope.isShowLoader = false;
        }

        GhDialog.show({
          class: 'gh-recycle-bin-dialog',
          position: 'full',
          template: {
            toolbar: /*html*/`
              <div class="gh-recycle-bin-dialog-toolbar">
                <div class="gh-recycle-bin-dialog-title">
                  <span gh-icon="recycle_bin 0D99FF 40px"></span>
                  <p>{{translate('Recycle Bin')}}</p>
                </div>
                <div class="recycle-bin-actions-row">
                  <div class="gh-btn btn-red restore-recycle-bin-btn" ng-click="restore()">{{translate('Restore')}}</div>
                  <div class="gh-recycle-bin-columns-toggle">
                    <div class="gh-recycle-bin-columns-toggle-btn" ng-click="$event.stopPropagation(); columnsMenuOpen = !columnsMenuOpen">
                      <span gh-icon="eye_hide 0D99FF 36px"></span>
                      <span class="gh-recycle-bin-columns-toggle-label">{{translate('Hide Columns')}}</span>
                    </div>
                    <div class="gh-recycle-bin-columns-menu" ng-if="columnsMenuOpen" ng-click="$event.stopPropagation()">
                      <label class="gh-recycle-bin-columns-menu-item" ng-repeat="column in tableModel.data_model.table_settings.columns_to_view">
                        <input type="checkbox" ng-model="column.show" ng-true-value="1" ng-false-value="0">
                        <span>{{column.field_name}}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            `,
            content: /*html*/`
              <div class="recycle-wrapper">
                  <gh-filter-advanced field-model="filterModel"></gh-filter-advanced>
                  <div class="gh-table-wrap"><gh-recycle-bin-table class="gh-table" gh-field-data="tableModel" gh-app-id="{{appId}}"></gh-recycle-bin-table></div>
              </div>
            `
          },
          locals: {
            fieldModel: $scope.fieldModel,
            trashItems: $scope.trashItems,
            translate: $scope.translate
          },
          controller: ['$scope', '$document', 'fieldModel', 'trashItems', 'translate', async function ($scope, $document, fieldModel, trashItems, translate) {
            $scope.translate = translate;
            $scope.appId = fieldModel.data_model.app_id;
            $scope.selectedItems = [];
            $scope.fieldModel = fieldModel;

            $scope.columnsMenuOpen = false;
            const closeColumnsMenu = () => {
              if ($scope.columnsMenuOpen) {
                $scope.columnsMenuOpen = false;
                $scope.$apply();
              }
            };
            $document.on('click', closeColumnsMenu);
            $scope.$on('$destroy', () => $document.off('click', closeColumnsMenu));

            const fieldIdForFilter = `recycle_bin_field_id_${fieldModel.data_model.app_id}`;
            $scope.filterModel = {
              data_model: {
                app_id: $scope.appId,
                field_id: fieldIdForFilter,
                disable_filter_auto_save: 0
              },
              field_id: fieldIdForFilter,
            }

            $scope.tableModel = {
              field_id: fieldIdForFilter,
              data_model: {
                app_id: $scope.fieldModel.data_model.app_id,
                filters_list: [],
                replace_items: trashItems,
                table_settings: {
                    columns_to_view: $scope.fieldModel.data_model.fields, /* Array of column settings, wich view in table.*/
                    /* Height of table (Row items count)*/
                    action: '',
                    /* Action on click on item*/
                    selected_item: 1, /* Can be item will be selected. '0' - Not selected, '1' - selected*/
                    items_order: 'increase'
                },
              }
            }

            $scope.$on('select-table-item', (event, data) => {
              $scope.selectedItems = data;
            });

            $scope.restore = async () => {
              if($scope.selectedItems.length) {
                try {
                  await gudhub.restoreItems($scope.appId, $scope.selectedItems);
                  gudhub.util.clearSelectedItems($scope.appId);
                  ghToastService.simple('Item(s) was successfully restored!', 'bottom right');
                }
                catch(e) {
                  gudhub.util.clearSelectedItems($scope.appId);
                  ghToastService.simple('Error when try to restore items. Please, try again!', 'bottom right');
                  console.error(e)
                }
                finally {
                  $scope.hide();
                }
              }
            }
          }]
        })
      }
    }],
    template: /*html*/`
    <div ng-if="fieldModel.data_model.mode === 'app'" ng-click="openDialog()" class="wrapper-recycle-bin-icon" ng-class="{'disabled': isShowLoader}">
      <gh-loader color="blue" ng-if="isShowLoader"></gh-loader>
      <div class="apps-list-icon" ng-if="!isShowLoader" gh-icon="{{fieldModel.data_model.icon.icon_id}} {{fieldModel.data_model.icon.icon_color}} 110px app {{fieldModel.data_model.icon.gradient_up}} {{fieldModel.data_model.icon.gradient_down}}"></div>
      <div class="name">{{fieldModel.data_model.name}}</div>
    </div>
    <div ng-if="!fieldModel.data_model.mode" gh-icon="recycle_bin 0D99FF 24px" ng-click="openDialog()" class="gh-recycle-bin"></div>
      `
  }
}])